export default 'tickets';
